import Vue from '../../plugins/vueFactory';
import * as VueGoogleMaps from 'vue2-google-maps';
import dealermodule from './components/dealermodule.vue';
import VueRouter from 'vue-router';
import GmapCluster from 'vue2-google-maps/src/components/cluster';
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD5WspAIwpEyzafqtu7oCz2vf-s6hvkgq4',
    libraries: 'places'
  },
  installComponents: true
});

Vue.component('GmapCluster', GmapCluster);

Vue.use(VueRouter);

Vue.use(VueGtm, {
  id: 'GTM-MPJQVKW',
  debug: process.env.NODE_ENV === 'development'
});

const router = new VueRouter({
  mode: 'history'
});

const elDealerModule = document.querySelector('.vue-dealermodule');

if (elDealerModule) {
  var objSettings = window.settings;

  // eslint-disable-next-line no-new
  new Vue({
    el: '.vue-dealermodule',
    render: (h) =>
      h(dealermodule, {
        props: {
          settings: objSettings
        }
      }),
    router
  });
}
